<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>บัญชีผู้ใช้งาน</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-text>
        <div>USERNAME: {{personData.username}}</div>
        <div>ROLES: <span v-for="item in personData.authorities" :key="item.id">{{item.authority}}</span></div>
        <v-text-field
            label="password"
            v-model="personData.password"
            outline
          ></v-text-field>
          <!-- <div v-for="(role, idx) in roleItems" :key="role.id">
            <v-checkbox :ref="`cb_${idx}`" v-model="personData.authorities" :label="role.authority" :value="role" :readonly="role.authority == 'ROLE_ADMIN'"></v-checkbox> 
          </div> -->
      </v-card-text>
      <v-card-actions>
        <v-layout>

          <v-spacer></v-spacer>
          <v-btn
            v-if="hasAccess(allowedRoles)"
            color="green white--text"
            @click="submit"
            :disabled="!valid"
          >
            บันทึก
          </v-btn>
          </v-layout>
      </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'

export default {
  props: [ 'personId' ],
  mixins: [ hasAccessMixin ],
  data: () => ({
    allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
    dialog: false,
    valid: false
  }),

  computed: {
    ...mapGetters({
      personData: 'person/personData',
      roleItems: 'person/roleItems'
    })
  },

  watch: {

  },

  created () {

  },

  methods: {
    submit () {
      // console.log(this.$refs.cb_1[0].value)
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store.dispatch('person/update', this.personData)
          .then((response) => {
            // console.log('onSave:', response )
            this.personData.password = ""
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              // TODO
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/person/shows/account/index.vue